import { Tabs, Tab } from '@mui/material';

import { makeStyles, withStyles } from '@mui/styles';

const style = makeStyles((theme: any) => ({
  container: {
    paddingTop: '15px',
    paddingBottom: '15px',
  },

  containerWrap: {
    position: 'sticky',
    top: 64,
    zIndex: 3,
    backgroundColor: '#fff',
  },

  tab: {
    zIndex: 2,
  },
  [theme.breakpoints.down('md')]: {
    containerWrap: { top: 64 },
  },
}));
export default style;

export const TabsContainer = withStyles(({ palette }) => ({
  root: {
    color: (props) =>
      props.iscommunity ? '#000000de' : palette.tertiary.purplishBlue,
  },
  vertical: {
    selected: { color: '#000', zIndex: 2 },
  },
  indicator: {
    height: '100%',
    backgroundColor: (props) =>
      props.iscommunity ? 'black' : palette.tertiary.purplishBlue,
    borderRadius: 45,
    color: 'white',
    zIndex: 1,
  },
  scrollButtons: {
    opacity: '0.8',
    backgroundColor: '#e4dcfa',
    borderRadius: '50%',
    width: 46,
    height: 46,
  },
}))(Tabs);

export const ActiveTab = withStyles({
  root: {
    '&$selected': {
      color: 'white',
    },
  },
  selected: {},
})(Tab);
